import { NetworkAvailableFeature } from '../../auth/networkFeatures';
import { hasShigoPermission, ShigoPermission } from '../../auth/permissions';
import { PublisherDetailsTab } from './model';

export const publisherDetailsTabPermissions = {
  [PublisherDetailsTab.Overview]: ShigoPermission.SupplyPublishersOverviewRead,
  [PublisherDetailsTab.Apps]: ShigoPermission.SupplyPublishersAppsRead,
  [PublisherDetailsTab.Domains]: ShigoPermission.SupplyPublishersDomainsRead,
  [PublisherDetailsTab.Placements]: ShigoPermission.SupplyPublishersPlacementsRead,
  [PublisherDetailsTab.AppRequests]: ShigoPermission.SupplyPublishersAppRequestsRead,
  [PublisherDetailsTab.A2v]: ShigoPermission.SupplyPublishersA2vRead,
} as const;

export const publisherDetailsTabOrder = Object.values(PublisherDetailsTab);

export function resolveAvailablePublisherDetailsTabs(
  permissions: readonly string[],
  networkFeatures: readonly NetworkAvailableFeature[],
) {
  const hasA2vFeature = networkFeatures.includes(NetworkAvailableFeature.A2v);
  return publisherDetailsTabOrder.filter(
    (tab) =>
      hasShigoPermission(permissions, publisherDetailsTabPermissions[tab]) &&
      (tab !== PublisherDetailsTab.A2v || hasA2vFeature),
  );
}
